import { PartyLedger } from "@/components/shared/party-ledger";
import { usePostVendorAdjustment, useVendorLedger } from "@/features/vendors/api";
import { useVendorId } from "@/features/vendors/detail/use-vendor-id";

export function VendorLedgerPage() {
  const vendorId = useVendorId();
  const { data: rows = [], isLoading } = useVendorLedger(vendorId);
  const post = usePostVendorAdjustment(vendorId);

  return (
    <PartyLedger
      partyLabel="vendor"
      balanceHint="What you owe this supplier. Bills increase to-pay; payments reduce it."
      rows={rows}
      isLoading={isLoading}
      posting={post.isPending}
      onPostAdjustment={(values) => post.mutateAsync(values)}
    />
  );
}
